import { useCallback } from 'react'
import { twinFetchPostText } from '../../../utils/globals/data'
import ButtonModalSortList, { ItemSortFunction } from '../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../baseComponents/Sorts/ButtonModalSortList/types'
import { TwinDictionary } from '../../../utils/globals/dictionary'

interface CategoriesSortButtonProps extends BaseButtonModalSortListProps {
    extraWhereParams?: TwinDictionary
}

const CategoriesSortButton: React.FC<CategoriesSortButtonProps> = ({ ...rest }) => {
    const { updateCategory } = useCategoriesSortButtonLogic()
    return (
        <ButtonModalSortList updateData={updateCategory} getDataFrom='/api/app/product/category/getAllCategories' {...rest} />
    )
}

const useCategoriesSortButtonLogic = () => {
    const updateCategory: ItemSortFunction = useCallback(async (data) => {
        const resp = await twinFetchPostText('/api/app/product/category/updateCategoryOrder', { categories: data })
        if (resp) {
            return true
        }
        return false
    }, [])

    return { updateCategory }
}

export default CategoriesSortButton